<template>
  <CommonHeader title="Tableau de bord" />
  <LayoutContainer>
    <CompositeAdminStat />
    <CompositeNpsDashboard class="nps-dashboard" />
  </LayoutContainer>
</template>

<script setup lang="ts">
import CommonHeader from '@/components/common/CommonHeader.vue'
import LayoutContainer from '@/components/layout/LayoutContainer.vue'
import CompositeAdminStat from '@/components/composite/CompositeAdminStat.vue'
import CompositeNpsDashboard from '@/components/composite/nps/CompositeNpsDashboard.vue'
</script>

<style scoped lang="scss">
.nps-dashboard {
  margin-top: 30px;
}
</style>
